const trimValues = <T extends Record<string, unknown>>(values: T): T => {
	const data = { ...values };

	(Object.keys(data) as (keyof T)[]).forEach(key => {
		const value = data[key];
		if (value && typeof value === 'string') {
			data[key] = value.trim() as T[keyof T];
		}
	});

	return data;
};

export default trimValues;
